import { colorsForStandard, COLOR_HEX } from "@/lib/modules";

export const FIBER_NAMES = ["Czerwony", "Zielony", "Niebieski", "Żółty", "Fioletowy", "Biały",
  "Pomarańczowy", "Turkusowy", "Czarny", "Brązowy", "Różowy", "Szary"];
// Jedno źródło prawdy o kolorach: COLOR_HEX z lib/modules (spójne z ODF i resztą UI)
export const HEX_BY_NAME = COLOR_HEX;
export const FIBER_HEX = FIBER_NAMES.map((nm) => COLOR_HEX[nm]);
export const fiberHex = (n) => FIBER_HEX[(Number(n) - 1) % 12];

// Nazwa koloru włókna nr n wg standardu kabla (fallback: globalny domyślny)
export const fiberNameStd = (settings, cable, n) => {
  const name = (cable && cable.fiber_standard) || (settings && settings.default_fiber_standard);
  const cols = colorsForStandard(settings, name);
  return cols[(((Number(n) || 1) - 1) % cols.length + cols.length) % cols.length];
};
// Hex koloru włókna wg standardu kabla
export const fiberHexStd = (settings, cable, n) => HEX_BY_NAME[fiberNameStd(settings, cable, n)] || fiberHex(n);
// kolor włókna wg koloru TUBY z kabla (dynamicznie); fallback do standardu kabla
export const tubeColorHex = (cable, n, settings) => {
  const tubes = cable && cable.tube_colors;
  if (tubes && tubes.length) {
    const per = Number(cable.fibers_per_tube) || 12;
    const idx = Math.ceil(Number(n) / per) - 1;
    const nm = tubes[idx];
    if (nm && HEX_BY_NAME[nm]) return HEX_BY_NAME[nm];
  }
  return fiberHexStd(settings, cable, n);
};
export const splOutputs = (s) => { const m = /1:(\d+)/.exec(s.split_type || ""); return m ? Math.min(64, parseInt(m[1], 10)) : 8; };

export function exportPng(svg, closureId, closureNumber, toast, t, legendNames) {
  if (!svg) return;
  const w = svg.width.baseVal.value || svg.getBoundingClientRect().width;
  const h = svg.height.baseVal.value || svg.getBoundingClientRect().height;
  const clone = svg.cloneNode(true);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const bg = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  bg.setAttribute("x", 0); bg.setAttribute("y", 0);
  bg.setAttribute("width", w); bg.setAttribute("height", h); bg.setAttribute("fill", "#0b1120");
  clone.insertBefore(bg, clone.firstChild);
  const svgStr = new XMLSerializer().serializeToString(clone);
  const img = new Image();
  const scale = 2;
  const HEAD = 56, FOOT = 40;
  const names = (legendNames && legendNames.length) ? legendNames : FIBER_NAMES;
  const legend = names.map((nm, i) => `${i + 1} ${nm}`);
  img.onload = () => {
    const cw = Math.max(w, 560), ch = h + HEAD + FOOT;
    const canvas = document.createElement("canvas");
    canvas.width = cw * scale; canvas.height = ch * scale;
    const ctx = canvas.getContext("2d");
    ctx.scale(scale, scale);
    ctx.fillStyle = "#0b1120"; ctx.fillRect(0, 0, cw, ch);
    ctx.fillStyle = "#22d3ee"; ctx.font = "bold 17px Arial, sans-serif";
    ctx.fillText(`Schemat spawów — mufa ${closureNumber || String(closureId).slice(0, 8)}`, 12, 26);
    ctx.fillStyle = "#94a3b8"; ctx.font = "12px Arial, sans-serif";
    ctx.fillText(new Date().toLocaleString("pl-PL"), 12, 46);
    ctx.drawImage(img, 0, HEAD, w, h);
    let lx = 12; let ly = h + HEAD + 14;
    ctx.font = "11px Arial, sans-serif";
    legend.forEach((nm, i) => {
      const tw = ctx.measureText(nm).width;
      if (lx + 16 + tw > cw - 8) { lx = 12; ly += 15; }
      ctx.fillStyle = HEX_BY_NAME[names[i]] || FIBER_HEX[i]; ctx.fillRect(lx, ly - 9, 10, 10);
      ctx.strokeStyle = "#475569"; ctx.strokeRect(lx, ly - 9, 10, 10);
      ctx.fillStyle = "#cbd5e1"; ctx.fillText(nm, lx + 14, ly);
      lx += 14 + tw + 14;
    });
    canvas.toBlob((blob) => {
      if (!blob) { toast.error(t("Nie udało się wygenerować obrazka")); return; }
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `schemat_mufy_${(closureNumber || String(closureId).slice(0, 8)).replace(/[^\w-]+/g, "_")}.png`;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success(t("Pobrano schemat PNG"));
    }, "image/png");
  };
  img.onerror = () => toast.error(t("Nie udało się wygenerować obrazka"));
  img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgStr)));
}
